import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase";

export function useAdminAuth() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsAdmin(false);
        setIsLoading(false);
        return;
      }
      // Primero el token fresco (por si te dieron o sacaron el admin hace un rato). Sin
      // señal eso falla: caemos al token que ya está guardado en el dispositivo, así el
      // admin instalado en el celu abre igual en el subte y muestra lo último (las reglas
      // de Firestore y el backend validan el claim real de todos modos).
      let tokenResult = null;
      try {
        tokenResult = await user.getIdTokenResult(true);
      } catch {
        try { tokenResult = await user.getIdTokenResult(); } catch { tokenResult = null; }
      }
      setIsAdmin(!!(tokenResult && tokenResult.claims.admin));
      setIsLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return { isAdmin, isLoading };
}

export async function getAdminToken() {
  const user = auth.currentUser;
  if (!user) throw new Error("No hay usuario autenticado");
  return user.getIdToken();
}
